import { Button, Typography } from '../../../../../../../components';
import React, { FC } from 'react';

import { AccordionBodyProps } from './accordion-body.types';
import { ReactComponent as Approve } from '../../../../../assets/icons/active-approve.svg';
import { ReactComponent as Cancel } from '../../../../../assets/icons/active-cancel.svg';
import classNames from 'classnames';
import styles from './accordion-body.module.scss';

/**
 * AccordionBody component
 * @description Body of accordion
 *
 * @author Vitalii Bodnarchuk, Oleksii Medvediev
 * @category Components
 */
const AccordionBody: FC<AccordionBodyProps> = ({ items, isMessage, addBottomClose, bottomCloseTxt, onClose }) => (
  <div className={styles.accordionBody}>
    {items.map(({ icon, text, status, htmlText, ignoreSVGColor }, idx) => (
      <div key={idx} className={classNames(styles.row, !ignoreSVGColor && styles.svgColor)}>
        <Typography.Text variant={'bodyText3'} className={classNames(typeof text !== 'string' && styles.flex)}>
          {htmlText ? (
            <div dangerouslySetInnerHTML={{ __html: htmlText }} style={isMessage ? { opacity: 0.5 } : undefined} />
          ) : (
            <span
              style={{
                opacity: isMessage ? 0.5 : undefined,
                width: '100%',
              }}
            >
              {text}
            </span>
          )}
        </Typography.Text>
        {typeof status !== 'undefined' && (
          <div className={styles.statusIcon}>
            {status === 0 ? <Cancel className={styles.cancel} /> : <Approve className={styles.approve} />}
          </div>
        )}
        {icon && icon}
      </div>
    ))}
    {addBottomClose && (
      <Button size={'medium'} variant={'outline'} onClick={onClose}>
        {bottomCloseTxt}
      </Button>
    )}
  </div>
);

export { AccordionBody };
